import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useCallback, useMemo, useState } from 'react'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import ECharts from '~/components/echarts'
import Select from '~/components/select'
import { azureDiskBytesResourceIdChartPath, azureDiskOpsResourceIdChartPath } from '~/routes'

export default function AzureDiskMetrics({ organizationId: orgId, resourceId: reId }) {
  const [params, setParams] = useState({ metrics_time_frame: '1w' })
  const metricsTimeFrames = useMemo(
    () => [
      { label: t`1 Week`, value: '1w', default: true },
      { label: t`1 Month`, value: '1m' },
      { label: t`3 Months`, value: '3m' },
    ],
    [],
  )

  const onChange = useCallback((name, values) => {
    // update params when a filter is selected
    setParams((prevParams) => ({ ...prevParams, [name]: values }))
  }, [])

  const diskBytesChartUrl = useMemo(() => azureDiskBytesResourceIdChartPath(orgId, reId), [orgId, reId])
  const diskOpsChartUrl = useMemo(() => azureDiskOpsResourceIdChartPath(orgId, reId), [orgId, reId])

  return (
    <div className='card'>
      <h3 className='card-header'>
        <Trans>Monitor Information</Trans>
      </h3>
      <div className='card-body'>
        <div className='row mb-3 gx-2 gy-2 align-items-center'>
          <div className='col-sm-4'>
            <Select
              label={t`Time Frame`}
              name='metrics_time_frame'
              onChange={onChange}
              options={metricsTimeFrames}
              selected={params.metrics_time_frame}
            />
          </div>
        </div>
        <Tabs id='uncontrolled-metrics-tabs' className='mb-3'>
          <Tab eventKey='bytes-per-second' title={t`Composite Disk Bytes/sec`} mountOnEnter>
            <div className='row g-0'>
              <div className='col-sm-12'>
                <ECharts
                  title={t`Bytes per Second`}
                  chartInfoTitle='azure_disk_bytes_per_second'
                  url={diskBytesChartUrl}
                  params={params}
                />
              </div>
            </div>
          </Tab>
          <Tab eventKey='ops-per-secund' title={t`Composite Disk Operations/sec`} mountOnEnter>
            <div className='row g-0'>
              <div className='col-sm-12'>
                <ECharts
                  title={t`Operations per Second`}
                  chartInfoTitle='azure_disk_operations_per_second'
                  url={diskOpsChartUrl}
                  params={params}
                />
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}
